export default __webpack_public_path__ + "static/media/PREVPAGE_ICON.2457f42c.svg";